// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] || chunkId) + "." + {"72":"94b9a36d","102":"713fa28f","133":"bdf6dcb0","169":"5c45d9a0","182":"812a5559","370":"cad9ecf3","402":"142608ea","453":"e57d2afa","662":"a434f164","721":"b44ab731","846":"d7264598","864":"edd99fb0"}[chunkId] + ".chunk.js";
};